module.exports = __webpack_public_path__ + "static/img/power-pole-mk-1_256.5dbdf62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/power-pole-mk-1_256.png
// module id = ozFE
// module chunks = 0